import { useEffect, useState } from 'react';
import UAParser from 'ua-parser-js';
import { InstaApp } from 'components/InstaApp';
import { SmartBanner } from 'components/SmartBanner';
import { createUrlForAndroid, createUrlForIos } from 'qr/utils/utils';
import { useRouter } from 'next/router';

import SVGIcon from '../public/svg/background.svg';

import type { OS } from 'src/shared/types';

/**
 * We don't want to make a fetch for restaurant data.
 */
const DetailWithoutRestaurant = () => {
    const [os, setOs] = useState<OS | undefined>(undefined);
    const [isBrowserSafari, setIsBrowserSafari] = useState<boolean>(false);

    const router = useRouter();
    let component;
    useEffect(() => {
        const uaParser = new UAParser();
        const browserName = uaParser.getBrowser().name?.toLocaleLowerCase() || '';

        setOs(uaParser.getOS().name?.toLocaleLowerCase() as OS);
        setIsBrowserSafari(!!browserName.match('safari'));
    }, []);

    useEffect(() => {
        if (os !== undefined && os !== 'ios' && os !== 'android') router.push('https://qerko.com?restaurant-not-found');
    });

    if (os === 'android') {
        component = (
            <>
                {/* INSTA_APP on android is triggered by click on button */}
                <InstaApp
                    restaurantName=""
                    urlPayByQerkoApp={createUrlForAndroid().storeUrl}
                    urlRestaurantBackground=""
                    urlRestaurantBackgroundPlaceholder={SVGIcon.src}
                    urlRestaurantLogo=""
                />
            </>
        );
    } else if (os === 'ios') {
        component = (
            <>
                {/* AppClip and SmartBanner is triggered by meta tag in html > head */}
                <SmartBanner isBrowserSafari={isBrowserSafari} os={os} urlIosStore={createUrlForIos().storeUrl} />
            </>
        );
    }

    return (
        <>
            {component}
        </>
    );
};

export default DetailWithoutRestaurant;
